<script>
    import{user_data} from './stores.js';
    import { onMount } from "svelte";
    import Iqtemplate from "./components/iqtemplate.svelte";
    import Chipscompnent from './components/chipscompnent.svelte';
    import {link, location, push, pop, replace} from 'svelte-spa-router';


    onMount(async() => {

    });

</script>

<Iqtemplate>
    <div class="cszinputcontainer">
        <div class="cszinputfieldcontainer">
            <div class="progresstext">2/6</div>
            <div class="csztopcopy">
                Is your loan amount below $647,000?
            </div>
            <Chipscompnent
            chipsdata={ [
                {sz: "med", s: false, t: "Yes", i:"/img/Check.svg", cbf:()=>{$user_data.does_qualify = true;}, n: "#/credit_score"},
                 {sz: "med", s: true, t: "No", i:"/img/X.svg", cbf:()=>{$user_data.does_qualify = false; console.log("!!!! I GOT CALLED SOMEHOW!");}, n: "#/credit_score"},
            ] }
            />

            <div class="progressbuttonholder">
                <button on:click={()=>{push("#/");}} class="backbutton"><span class="backarrowcontainer"><img src="/img/triangle-left-arrow.svg" alt="back arrow" /></span>Go Back</button>
            </div>

        </div>
    </div>

</Iqtemplate>

<style>

</style>